

<template>
  <div class="flex w-full">
    <div class="vx-col w-full max-auto self-center">
      <vx-card class="shadow-md">
        <div class="vx-row">
          <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-4 mx-auto self-center">
            <h6>Select Zone</h6>
            <v-select
              @change="makeLocationList"
              class="w-full"
              :clearable="false"
              v-model="selectedZone"
              :options="availableZones"
            ></v-select>
          </div>
          <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-4 mx-auto self-center">
            <h6>Select Location</h6>
            <v-select
              :disabled="selectedZone.value == 'SelectZone'"
              @change="makeModemList"
              class="w-full"
              :clearable="false"
              v-model="selectedLocation"
              :options="availableLocations"
            ></v-select>
          </div>
          <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-4 mx-auto self-center">
            <h6>Select Modem</h6>
            <v-select
              :disabled="selectedLocation.value == 'SelectLocation' || selectedZone.value =='SelectZone' || selectedLocation.value =='noLocation'"
              @change="checkSelectedModem"
              class="w-full"
              :clearable="false"
              v-model="selectedModem"
              :options="availableModems"
            ></v-select>
          </div>
          <div
            class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mt-2 mx-auto self-center text-center"
          >
            <vs-button
              :disabled="selectedModem.value == 'SelectModem' || selectedModem.value == '' || selectedModem.value == 'noModem'"
              class="mr-6"
              color="dark"
              type="gradient"
              @click="returnModemId"
            >{{buttonText}}</vs-button>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";

export default {
  data() {
    return {
      availableZones: [],
      availableLocations: [],
      availableModems: [],
      selectedZone: "",
      selectedLocation: "",
      selectedModem: "",
      buttonText: "Search"
    };
  },
  created() {
    var routeName = this.$route.name;

    if (routeName == "energyConsumption" || routeName == "modemStatus") {
      this.buttonText = "Get Report";
    } else if (routeName == "dimmingPolicy") {
      this.buttonText = "Set Policy";
    } else {
      this.buttonText = "Search";
    }

    var data = this.$store.state.zones;
    var zones = [];
    zones.push({ label: "Select Zone", value: "SelectZone" });
    var sortedData = data.sort(function(a, b) {
      var nameA = a.zoneName.toUpperCase(); // ignore upper and lowercase
      var nameB = b.zoneName.toUpperCase(); // ignore upper and lowercase
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }

      // names must be equal
      return 0;
    });
    for (var x in sortedData) {
      zones.push({ label: sortedData[x].zoneName, value: sortedData[x].id });
    }
    if (zones.length == 1) {
      zones = [];
      zones.push({ label: "No Zones Available", value: "noZone" });
      this.availableZones = zones;
      this.selectedZone = { label: "No Zones Available", value: "noZone" };
    } else {
      this.availableZones = zones;
      this.selectedZone = { label: "Select Zone", value: "SelectZone" };
    }
  },
  computed: {},
  methods: {
    makeLocationList() {
      var locations = this.$store.state.locations;
      var selectedZone = this.selectedZone.value;
      var locationsData = [];
      locationsData.push({ label: "Select Location", value: "SelectLocation" });
      var sortlocations = locations.sort(function(a, b) {
        var nameA = a.locationName.toUpperCase();
        var nameB = b.locationName.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
      for (var x in sortlocations) {
        if (sortlocations[x].locationZone == selectedZone) {
          locationsData.push({
            label: sortlocations[x].locationName,
            value: sortlocations[x].id
          });
        }
      }
      if (locationsData.length == 1) {
        locationsData = [];
        locationsData.push({
          label: "No Locations Available",
          value: "noLocation"
        });
        this.availableLocations = locationsData;
        this.selectedLocation = {
          label: "No Locations Available",
          value: "noLocation"
        };
      } else {
        this.availableLocations = locationsData;
        this.selectedLocation = {
          label: "Select Location",
          value: "SelectLocation"
        };
      }
      this.$emit("disableSave", true);
    },
    makeModemList() {
      var modems = this.$store.state.modems;
      var selectedLocation = this.selectedLocation.value;
      var modemData = [];
      modemData.push({ label: "Select Modem", value: "SelectModem" });
      var sortModems = modems.sort(function(a, b) {
        var nameA = a.modemName.toUpperCase();
        var nameB = b.modemName.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
      for (var m in sortModems) {
        if (sortModems[m].modemLocation == selectedLocation) {
          modemData.push({
            label: sortModems[m].modemName,
            value: sortModems[m].modemId
          });
        }
      }

      if (modemData.length == 1) {
        modemData = [];
        modemData.push({
          label: "No Modem Available",
          value: "noModem"
        });
        this.availableModems = modemData;
        this.selectedModem = {
          label: "No Modem Available",
          value: "noModem"
        };
      } else {
        this.availableModems = modemData;
        this.selectedModem = { label: "Select Modem", value: "SelectModem" };
      }

      this.$emit("disableSave", true);
    },
    returnModemId() {
      var selectedModem = this.selectedModem.value;
      console.log(selectedModem);
      this.$emit("selectedModem", selectedModem);
    },
    checkSelectedModem() {
      var selectedModem = this.selectedModem.value;
      if (
        selectedModem == "SelectModem" ||
        selectedModem == "" ||
        selectedModem == "noModem"
      ) {
        this.$emit("disableSave", true);
      }
    }
  },
  components: {
    "v-select": vSelect
  }
};
</script>


